import apiClient from '@/axios';

export async function fetchMenuData() {
  try {
    const response = await apiClient.get('/menu?new=1');
    const data = response.data;

    return {
  
      fetchedNotificationMessage: data.auction_notice.message,
      auctionStatus: data.auction_notice.status,
      startDate: new Date(data.auction_notice.start_date),
      endDate: new Date(data.auction_notice.end_date),
      };
  } catch (error) {
    console.error("Error fetching menu data:", error);
    return null;
  }
}

export async function updateLiveAuctionLink() {
  try {
    const response = await apiClient.get('/menu?new=1');
    const data = response.data;
    const auctionNotice = data.auction_notice;
    const liveAuctionUrl = data.HeaderMenu.menu_grid_1.items[0].url;
    
    // Target all LIVE AUCTION links
    const liveLinks = document.querySelectorAll('.live-auction-link');
    const liveNavs = document.querySelectorAll('.live-auction-nav');
    
    if (auctionNotice.status === 'live' || auctionNotice.status === 'extended') {
      // Show and update links
      liveNavs.forEach(nav => nav.style.display = '');
      liveLinks.forEach(link => link.href = liveAuctionUrl);
    } else {
      // Hide links
      liveNavs.forEach(nav => nav.style.display = 'none');
    }
  } catch (error) {
    console.error('Error updating live auction link:', error);
  }
}
